import React, { PureComponent } from 'react';
import { Translate } from 'react-redux-i18n';
import moment from 'moment-timezone';

import StringUtil from '../../app/utils/string';

class PromotionImportErrors extends PureComponent {
  render() {
    const { errors = [] } = this.props;

    if (!errors.length) return null;

    return (
      <div className="items-errors">
        <hr />

        {errors.map((error, indicators) => (
          <React.Fragment key={error.code}>
            {(indicators === 0 || error.types[0] === 'substituted')
              ? <h5>{(error.types[0] === 'substituted')
                ? <Translate value="disabledPromotions" />
                : <Translate value="dragAndDropPromotionErrorTitle" />}</h5>
              : ''}
            <p>
              <Translate value="code" />
              {': '}
              <b>{error.code}</b>

              {' - '}
              {(error.types[0] === 'substituted')
                ?
                <React.Fragment key={`${error.code}keySub`}>
                  <Translate value="initDate" />
                  {' '}
                  {moment(error.startedAt).format('DD-MM-YYYY HH:mm:ss')}
                  {' - '}
                  <Translate value="finDate" />
                  {' '}
                  {moment(error.finalizedAt).format('DD-MM-YYYY HH:mm:ss')}
                  {': '}
                </React.Fragment>
                :
                <React.Fragment key={`${error.code}key`}>
                  <Translate value="line" />
                  {' '}
                  {error.line}
                  {': '}
                </React.Fragment>
              }

              {error.types.map((type, index) => (
                <React.Fragment key={`${error.code}${index}`}>
                  <Translate value={`dragAndDropPromotionError${StringUtil.capitalizeFirstLetter(type)}`} />
                  {index !== error.types.length - 1 ? ', ' : ''}
                </React.Fragment>
              ))}
            </p>
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default PromotionImportErrors;
